import { Controller } from 'stimulus';
import MitreTable from '../utils/mitre-table';
import dataExportUtilitySingleton from '../classes/DataExport';


class TableDownloadController extends Controller {
  static values = {
    slug: String
  };

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);
  }

  download = (e) => {
    e.preventDefault();

    const { collectionKey } = this._mitreTable.getParams();

    const { filters, theme, defaultFilters } = this._mitreTable.getParams();
    const options = {
      uuid: this._mitreTable.tableKey,
      collection: collectionKey,
      filters,
      theme,
      default_filters: defaultFilters
    };

    dataExportUtilitySingleton.startMitreTableExport(options);
  };
}

export default TableDownloadController;
